import { Box, Checkbox, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Instruction } from "../../models/Instruction";
import { useCallback } from "react";

export type InstructionsPageProps = {
  instructions: Instruction[];
  completedInstructions: number[];
  changeCompletedInstructions: any;
}

const InstructionsPage = (props: InstructionsPageProps) => {
  const completeInstruction = useCallback((id: number) => {
    props.changeCompletedInstructions((completed: number[]) => {
      if (completed.includes(id)) return completed.filter(i => i !== id);
      return [...completed, id];
    });
  }, [props]);

  const sorted = [...props.instructions].sort((a, b) => a.orderNumber - b.orderNumber);

  let lastGroup: string | undefined = undefined;

  return (
    <Box sx={{ width: '100%', maxWidth: 720, mx: 'auto', px: 2, overflowY: 'auto', overflowX: 'hidden' }}>
      <List>
        {sorted.map((instruction, idx) => {
          const showGroupHeader = instruction.groupName && instruction.groupName !== lastGroup;
          lastGroup = instruction.groupName ?? undefined;
          const completed = props.completedInstructions.includes(instruction.id!);

          return (
            <Box key={instruction.id}>
              {showGroupHeader && (
                <Box sx={{
                  px: 1, pt: idx === 0 ? 1.5 : 2.5, pb: 0.5,
                  fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.1em',
                  textTransform: 'uppercase', color: 'primary.main',
                }}>
                  {instruction.groupName}
                </Box>
              )}
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => completeInstruction(instruction.id!)}
                  dense
                  sx={{
                    borderRadius: 2,
                    mb: 0.5,
                    alignItems: 'flex-start',
                    opacity: completed ? 0.6 : 1,
                    transition: 'opacity 0.2s',
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 36, mt: 0.5 }}>
                    <Checkbox
                      edge="start"
                      checked={completed}
                      tabIndex={-1}
                      disableRipple
                      size="small"
                      sx={{ '&.Mui-checked': { color: 'primary.main' } }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={instruction.description}
                    primaryTypographyProps={{
                      fontWeight: 400,
                      sx: {
                        lineHeight: 1.6,
                        textDecoration: completed ? 'line-through' : 'none',
                        color: completed ? 'text.secondary' : 'text.primary',
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </Box>
          );
        })}
      </List>
    </Box>
  );
};

export default InstructionsPage;
